import { LocationStatus } from "./locations";

export class CompositeLocationItem {
    public locationID: number;
    public operator: string;
    public multiplier: number;
}


export interface CompositeLocationPostRequest {
    locationName: string;
    description: string;
    status: LocationStatus;
    latitude: number;
    longitude: number;
    components: CompositeLocationItem[];
}

export interface CompositeLocationPutRequest extends CompositeLocationPostRequest {
    locationID: number;
}
